var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('in-viewport',[_c('div',{staticClass:"photo-section"},[_c('base-layout',{attrs:{"hide-sidebar":""}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{staticClass:"photo-section__img",attrs:{"src":_vm.photo,"alt":""}})])])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67e122a0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Team/PhotoSection.vue
// module id = null
// module chunks = 